import React from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';

const stats = [
  { value: '300+', label: 'Builder Clients', sub: 'Across India' },
  { value: '2x', label: 'Deal Closure Speed', sub: 'Avg improvement' },
  { value: '80%', label: 'Lead Response Rate', sub: 'Within 48 hours' },
  { value: '₹500Cr+', label: 'Revenue Managed', sub: 'On our platform' },
];

const StatsBar = () => (
  <Box sx={{ bgcolor: '#0c1a3d', py: 5, borderBottom: '1px solid rgba(6,182,212,0.2)' }}>
    <Container maxWidth="lg">
      <Grid container spacing={2} justifyContent="center">
        {stats.map((s, i) => (
          <Grid item xs={6} md={3} key={i}>
            <Box sx={{ textAlign: 'center', borderRight: { md: i < 3 ? '1px solid rgba(255,255,255,0.08)' : 'none' }, px: 2 }}>
              <Typography sx={{ color: '#22d3ee', fontWeight: 900, fontSize: { xs: '1.8rem', md: '2.4rem' }, fontFamily: "'Montserrat', sans-serif", lineHeight: 1 }}>{s.value}</Typography>
              <Typography sx={{ color: '#fff', fontWeight: 700, fontFamily: "'Montserrat', sans-serif", fontSize: 14, mt: 0.5 }}>{s.label}</Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.45)', fontFamily: "'Montserrat', sans-serif", fontSize: 12, mt: 0.2 }}>{s.sub}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default StatsBar;
